import Modal from './modal/Modal';
import useModal from './modal/useModal';
import { ModalHeader, ModalContent, ModalBackdrop, ModalCloseButton } from './modal/Modal.styles';

export { Modal, useModal, ModalHeader, ModalContent, ModalBackdrop, ModalCloseButton };
export default Modal;
